import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Button } from "./ui/button";
import { trackViewContent } from "../lib/tracking";
import { scrollToSection } from "../lib/scrollToSection";

const MODULES = [
  {
    title: "Fundamente AI",
    body: "Ce este AI, cum gândesc modelele lingvistice, principalele instrumente disponibile gratuit pentru profesori și diferența dintre ChatGPT, Gemini, Claude. Demo-uri live la clasă.",
  },
  {
    title: "Prompt engineering pentru profesori",
    body: "Tehnici de scriere a prompturilor pentru rezultate de calitate didactică: rol, context, exemple, restricții, format. Șabloane gata de folosit pentru fiecare disciplină.",
  },
  {
    title: "Etică și gândire critică",
    body: "Confidențialitate, drepturi de autor, halucinații, bias, citarea AI. Cum discuți cu elevii despre folosirea responsabilă a AI și ce reguli adopți la clasă.",
  },
  {
    title: "Lecții asistate de AI",
    body: "Construirea integrală a unei lecții: obiective, captarea atenției, predare, fixare, evaluare formativă. Adaptare la programa școlară românească.",
  },
  {
    title: "Diferențierea învățării",
    body: "Generarea de variante de fișe, sarcini și texte pentru elevi cu nevoi diferite (CES, ritm propriu, performanți), pe baza aceleiași teme de lecție.",
  },
  {
    title: "Integrare pe discipline",
    body: "Aplicații concrete pentru: limba română, matematică, științe, istorie, geografie, limbi străine, învățământ primar și preșcolar.",
  },
  {
    title: "Materiale vizuale",
    body: "Imagini, infografice, hărți conceptuale, postere de clasă – generate cu AI, adaptate vârstei și design-ului profesional.",
  },
  {
    title: "Documente și prezentări",
    body: "Realizarea rapidă de prezentări, fișe de lucru, planuri de lecție și documente oficiale, pornind de la prompturi simple sau din materialele tale existente.",
  },
  {
    title: "Conținut educațional integrat",
    body: "Cum combini text, imagine și interactivitate într-o experiență coerentă pentru elev: de la suportul de curs până la activitățile de evaluare.",
  },
  {
    title: "Proiect final",
    body: "Realizezi un mic portofoliu: o unitate de învățare completă creată cu ajutorul AI, pe care o vei prezenta pentru obținerea certificatului de absolvire.",
  },
];

export default function Curriculum() {
  return (
    <section id="curriculum" className="scroll-mt-28 pt-20 md:pt-28 pb-12 md:pb-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center rounded-full bg-[#F0E7F4] px-3 py-1 text-xs font-semibold text-[#965EA7] uppercase tracking-widest">
              Programa cursului
            </span>
            <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-[#373A45]">
              10 module, structurate ca un parcurs aplicat.
            </h2>
            <p className="mt-4 text-[#6B7280] text-lg leading-relaxed">
              Fiecare modul include: explicații video, exerciții ghidate, șabloane gata de folosit la clasă și sesiuni Q&A live.
            </p>
            <Button
              onClick={() => {
                trackViewContent("curriculum_pdf");
                // M910 — CTA → suppress next popup firing once.
                scrollToSection("lead-form");
              }}
              className="mt-7 rounded-full bg-[#373A45] hover:bg-[#1F2128] text-white px-7 py-6 font-semibold"
              data-testid="curriculum-download-cta"
            >
              Descarcă programa PDF
            </Button>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="bg-white rounded-2xl border border-[#E5E7EB] px-6 md:px-8"
              data-testid="course-curriculum-accordion"
            >
              {MODULES.map((m, i) => (
                <AccordionItem key={i} value={`m-${i}`} className="border-b border-[#E5E7EB] last:border-b-0">
                  <AccordionTrigger
                    className="hover:no-underline hover:text-[#965EA7] py-5 text-left transition-colors group"
                    data-testid={`curriculum-trigger-${i}`}
                  >
                    <span className="flex items-center gap-4">
                      <span className="h-9 w-9 rounded-lg bg-[#EDEEF0] grid place-items-center text-sm font-bold text-[#373A45] group-hover:bg-[#965EA7] group-hover:text-white transition-colors">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-display text-lg md:text-xl font-semibold text-[#373A45]">
                        {m.title}
                      </span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-[3.25rem] text-[#6B7280] leading-relaxed">
                    {m.body}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
